export default {
    /* baseUrl: "https://tester.coredecimalsolutions.com/" */
    baseUrl: "/"
}